 <app-breadcrumb currentPage="Services"></app-breadcrumb>
<section class="page-hero">
    <!-- Section Title -->
    <div class="container">
        <span class="badge-label">DIGITAL SOLUTIONS &amp; INNOVATION</span>
        <!-- <h2>Services</h2> -->
        <!-- <p>Technology-driven solutions designed to simplify your business and accelerate growth.</p> -->
    </div><!-- End Section Title -->
    <div class="container">
        <h2 class="m-t-0">Digital Solutions Built Around Your Business</h2>
        <p>From websites and custom applications to SaaS solutions and ongoing technical support, we build practical
            technology solutions designed around your business needs.
        </p>
    </div>
</section>
<section class="services-main">
    <div class="container">
        <div class="service-grid">
            <article class="service-card">
                <div class="icon"><span>01</span></div>
                <h3>Web & Digital Solutions</h3>
                <p>Create a professional digital presence with modern, responsive, and user-focused websites and digital experiences.</p>
                <ul>
                    <li><i class="bi bi-check2-circle"></i> Business Website Development</li>
                    <li><i class="bi bi-check2-circle"></i> UI/UX Desig</li>
                    <li><i class="bi bi-check2-circle"></i> Responsive Web Design</li>
                    <li><i class="bi bi-check2-circle"></i> Corporate Websitess</li>
                    <li><i class="bi bi-check2-circle"></i> Website Redesign & Modernization</li>
                    <li><i class="bi bi-check2-circle"></i> SEO-ready Development</li>
                    <li><i class="bi bi-check2-circle"></i> Third-Party Integrations</li>
                </ul>
                <a routerLink="/contactus">Let's discuss your project <i class="bi bi-arrow-right"></i></a>
            </article>
            <article class="service-card">
                <div class="icon"><span>02</span></div>
                <h3>Software & Product Engineering</h3>
                <p>Turn your business idea into a reliable web application, SaaS product, or custom software solution.</p>
                <ul>
                    <li><i class="bi bi-check2-circle"></i> Product Ideation</li>
                    <li><i class="bi bi-check2-circle"></i> MVP Development</li>
                    <li><i class="bi bi-check2-circle"></i> Web Applications</li>
                    <li><i class="bi bi-check2-circle"></i> SaaS Platforms</li>
                    <li><i class="bi bi-check2-circle"></i> API & System Integration</li>
                    <li><i class="bi bi-check2-circle"></i> Testing & Deployment</li>
                    <li><i class="bi bi-check2-circle"></i> Continuous Enhancement</li>
                </ul>

                <a routerLink="/contactus">Let's discuss your project <i class="bi bi-arrow-right"></i></a>
            </article>
            <article class="service-card">
                <div class="icon"><span>03</span></div>
                <h3>Support & Maintenance</h3>
                <p>Keep your applications and websites running smoothly with ongoing technical support, maintenance, updates, and improvements.</p>
                <ul>
                    <li><i class="bi bi-check2-circle"></i> Application Support</li>
                    <li><i class="bi bi-check2-circle"></i> Bug Fixes & Issue Resolution</li>
                    <li><i class="bi bi-check2-circle"></i> Performance Improvements</li>
                    <li><i class="bi bi-check2-circle"></i> Security & Dependency Updates</li>
                    <li><i class="bi bi-check2-circle"></i> Feature Enhancements</li>
                    <li><i class="bi bi-check2-circle"></i> Maintenance & Monitoring</li>
                    <li><i class="bi bi-check2-circle"></i> Production Support</li>
                    <li><i class="bi bi-check2-circle"></i> Technical Troubleshooting</li>
                    <li></li>
                </ul>
                <a routerLink="/contactus">Let's discuss your project <i class="bi bi-arrow-right"></i></a>
            </article>
            <article class="service-card">
                <div class="icon"><span>04</span></div>
                <!-- <div class="icon"><i class="bi bi-code-slash"></i></div> -->
                <h3>Technology & Development Partnerships</h3>
                <!-- <p>Need additional development capacity for your projects?</p> -->
                 <!-- <p>clear and relevant to B2B clients.</p> -->
                <p>SPLEX INNOVATION partners with software companies, IT agencies, digital agencies, and SaaS businesses that need reliable development support.</p>
                <p><b class="text-white">We support your team through</b></p>
                <ul>
                    <li><i class="bi bi-check2-circle"></i> Project-based development</li>
                    <li><i class="bi bi-check2-circle"></i> Dedicated developer and team support</li>
                    <li><i class="bi bi-check2-circle"></i> White-label development</li>
                    <li><i class="bi bi-check2-circle"></i> Software development subcontracting</li>
                    <li><i class="bi bi-check2-circle"></i> SaaS development</li>
                    <li><i class="bi bi-check2-circle"></i> Application maintenance</li>
                    <li><i class="bi bi-check2-circle"></i> Long-term technology partnerships</li>
                </ul>

                <a routerLink="/contactus">Let's discuss your project <i class="bi bi-arrow-right"></i></a>
            </article>
        </div>


    </div>
</section>
<section class="services-cta">
    <div class="container">
        <div><span class="eyebrow">HAVE A PROJECT IN MIND?</span>
            <h2>Let's Build Something That Works for Your Business.</h2>
            <p>Tell us what you're looking to build, improve, or maintain. We'll understand your requirements and recommend a solution based on your goals and scope.</p>
        </div><a routerLink="/contactus" class="btn-primary-red">Get Started <i class="bi bi-arrow-right ms-2"></i></a>
    </div>
</section>